// filepath: /c:/Users/andre/Documents/development/demo-react-vis-app/src/store/store.js
import { configureStore } from '@reduxjs/toolkit';
import messagesReducer from '../reducers/messagesReducer';
import loadingReducer from '../reducers/loadingReducer';

const store = configureStore({
    reducer: {
        messages: messagesReducer,
        loading: loadingReducer,
    },
});

export default store;